export default __webpack_public_path__ + "static/media/rocket.bd8c26f0.svg";